<template>
    <b-container id="privacy-policies">
        <b-row>
            <b-col cols="12" class="mt-5-bt">
                <h1 class="mb-5-bt text-center">PRIVACY POLICY</h1>
                <p class="font-weight-normal">
                    This Privacy Policy (“<strong>Policy</strong>”) sets out the basis on which <strong>E M SERVICES PTE. LTD. (“E M Services”, “we”, “us” or “our”)</strong> may collect, use, disclose or otherwise process personal data of our Customers in accordance with the Personal Data Protection Act 2012 (the “<strong>Act</strong>”). This Policy applies to personal data in our possession or under our control including personal data in the possession of organisations which we have engaged to collect, use, disclose or process personal data for our purposes.
                </p>
                <p class="font-weight-normal">
                    By accessing and using the GOfix website or the GOfix mobile application (collectively, the “<strong>Platform</strong>”)  you agree to the consent to the collection, use and disclosure of your Personal Data in accordance with this Policy.
                </p>
                <p class="font-weight-normal">
                    If you do not consent to the collection, use and disclosure of your Personal Data in accordance with this Policy, do not access and/or use the Platform or the Services.
                </p>
                <b-row>
                    <b-col cols="1" class="font-weight-bold">1</b-col>
                    <b-col cols="11">
                        <strong>PERSONAL DATA</strong>
                    </b-col>
                    <b-col cols="1" class="mt-3">1.1</b-col>
                    <b-col cols="11" class="mt-3">
                        <strong>“Customer”</strong> (or <strong>“you”</strong>, <strong>“your”</strong>) means an inb-colidual who has
                        <b-row>
                            <b-col cols="1">(a)</b-col>
                            <b-col cols="11">
                                <span>contacted us through any means to find out more about any goods or services we provide, or</span>
                            </b-col>
                            <b-col cols="1">(b)</b-col>
                            <b-col cols="11">
                                <span>may, or has, entered into a contract with us for the supply of goods and services by us.</span>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="1" class="mt-3">1.1</b-col>
                    <b-col cols="11" class="mt-3">
                        <strong>“Personal Data”</strong> means data, whether true or not, about a customer who can be identified from:
                        <b-row>
                            <b-col cols="1">(a)</b-col>
                            <b-col cols="11">
                                <span>That data; or</span>
                            </b-col>
                            <b-col cols="1">(b)</b-col>
                            <b-col cols="11">
                                <span>That data and other information which we have or are likely to have access to.</span>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="1" class="mt-3">1.3</b-col>
                    <b-col cols="11" class="mt-3">
                        <span>Examples of personal data which may be collected from you, include but are not limited to the following:</span>
                        <b-row>
                            <b-col cols="1">(a)</b-col>
                            <b-col cols="11">
                                <span>your name;</span>
                            </b-col>
                            <b-col cols="1">(b)</b-col>
                            <b-col cols="11">
                                <span>contact information such as your residential address, email address, or telephone number;</span>
                            </b-col>
                            <b-col cols="1">(c)</b-col>
                            <b-col cols="11">
                                <span>personal particulars such as your nationality, date of birth, marital status,</span>
                            </b-col>
                            <b-col cols="1">(d)</b-col>
                            <b-col cols="11">
                                <span>photographs and other audio-visual information;</span>
                            </b-col>
                            <b-col cols="1">(e)</b-col>
                            <b-col cols="11">
                                <span>employment information; and</span>
                            </b-col>
                            <b-col cols="1">(f)</b-col>
                            <b-col cols="11">
                                <span>financial information such as credit card numbers, debit card numbers or bank account information.</span>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="1" class="mt-3 font-weight-bold">2</b-col>
                    <b-col cols="11" class="mt-3">
                        <strong>COLLECTION, USE AND DISCLOSURE OF PERSONAL DATA</strong>
                    </b-col>
                    <b-col cols="1" class="mt-3">2.1</b-col>
                    <b-col cols="11" class="mt-3">
                        <span>Your Personal Data may be collected by us generally only where:</span>
                        <b-row>
                            <b-col cols="1">(a)</b-col>
                            <b-col cols="11">
                                <span>you have provided it to us voluntarily, either directly or via a third party who has been duly authorised by you to disclose your Personal Data to us (your <strong>“Authorised Representative”</strong>) and;</span>
                                <b-row>
                                    <b-col cols="1">(i)</b-col>
                                    <b-col cols="11">
                                        <span>you, or where applicable, your Authorised Representative, have been notified of the purposes for which the data is collected; and</span>
                                    </b-col>
                                    <b-col cols="1">(ii)</b-col>
                                    <b-col cols="11">
                                        <span>you (or your Authorised Representative) have provided written consent to the collection and usage of your Personal Data for those purposes; OR</span>
                                    </b-col>
                                </b-row>
                            </b-col>
                            <b-col cols="1">(b)</b-col>
                            <b-col cols="11">
                                <span>collection and use of Personal Data without your consent is permitted or required by the Act or other laws.</span>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="1" class="mt-3">2.2</b-col>
                    <b-col cols="11" class="mt-3">
                        <span>We will seek your consent before collecting any Personal Data and before using your Personal Data for purposes which have not been notified to you, except where permitted or authorised by law.</span>
                    </b-col>
                    <b-col cols="1" class="mt-3 font-weight-bold">3</b-col>
                    <b-col cols="11" class="mt-3">
                        <strong>PURPOSES OF COLLECTION AND USE OF PERSONAL DATA</strong>
                    </b-col>
                    <b-col cols="1" class="mt-3">3.1</b-col>
                    <b-col cols="11" class="mt-3">
                        <span>We may collect and use your Personal Data for any or all of the following purposes:</span>
                        <b-row>
                            <b-col cols="1">(a)</b-col>
                            <b-col cols="11">
                                <span>performing obligations in the course of in connection with our provision of the goods and/or services requested by you;</span>
                            </b-col>
                            <b-col cols="1">(b)</b-col>
                            <b-col cols="11">
                                <span>verifying your identity;</span>
                            </b-col>
                            <b-col cols="1">(c)</b-col>
                            <b-col cols="11">
                                <span>responding to, handling, and processing queries, requests, applications, complaints and feedback from you;</span>
                            </b-col>
                            <b-col cols="1">(d)</b-col>
                            <b-col cols="11">
                                <span>managing your relationship with us;</span>
                            </b-col>
                            <b-col cols="1">(e)</b-col>
                            <b-col cols="11">
                                <span>processing payment or credit transactions;</span>
                            </b-col>
                            <b-col cols="1">(f)</b-col>
                            <b-col cols="11">
                                <span>sending you marketing information about our goods and/or services including notifying you of our marketing events, initiatives and promotions, lucky draws, memberships, reward schemes and other promotions;</span>
                            </b-col>
                            <b-col cols="1">(g)</b-col>
                            <b-col cols="11">
                                <span>complying with any applicable laws, regulations, codes of practice, guidelines, or rules to assist in law enforcement, and investigations conducted by any governmental and/or regulatory authority;</span>
                            </b-col>
                            <b-col cols="1">(h)</b-col>
                            <b-col cols="11">
                                <span>transmitting to any unaffiliated third parties, including our third-party service providers and agents, and</span>
                            </b-col>
                            <b-col cols="1">(i)</b-col>
                            <b-col cols="11">
                                <span>any other incidental business purposes related to or in connection with the above.</span>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="1" class="mt-3 font-weight-bold">4</b-col>
                    <b-col cols="11" class="mt-3">
                        <strong>DISCLOSURE OF PERSONAL DATA</strong>
                    </b-col>
                    <b-col cols="1" class="mt-3">4.1</b-col>
                    <b-col cols="11" class="mt-3">
                        <span>We may disclose your Personal Data in the following situations:</span>
                        <b-row>
                            <b-col cols="1">(a)</b-col>
                            <b-col cols="11">
                                <span>where such disclosure is required for performing obligations in the course of or in connection with our provision of the goods and/or services requested by you; or</span>
                            </b-col>
                            <b-col cols="1">(b)</b-col>
                            <b-col cols="11">
                                <span>to third party service providers, agents and other organisations we have engaged to perform any of the functions listed in clause 4.1(a) above for us.</span>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="1" class="mt-3">4.2</b-col>
                    <b-col cols="11" class="mt-3">
                        <span>
                            The purposes listed in the above clauses 3 and 4 may continue to apply even in situations where your relationship with us (for example, pursuant to a contract) has been terminated or altered in any way, for a reasonable period
                            thereafter (including, where applicable, a period to enable us to enforce our rights under any contract with you).
                        </span>
                    </b-col>
                    <b-col cols="1" class="mt-3 font-weight-bold">5</b-col>
                    <b-col cols="11" class="mt-3">
                        <strong>WITHDRAWING YOUR CONSENT</strong>
                    </b-col>
                    <b-col cols="1" class="mt-3">5.1</b-col>
                    <b-col cols="11" class="mt-3">
                        <span>The consent that you provide for the collection, use and disclosure of your Personal Data will remain valid until such time it is being withdrawn by you in writing.</span>
                    </b-col>
                    <b-col cols="1" class="mt-3">5.2</b-col>
                    <b-col cols="11" class="mt-3">
                        <span>
                            You may withdraw consent and request us to stop using and/or disclosing your Personal Data for any or all of the purposes listed above by submitting your request in writing or via email to our Data Protection Officer at the contact
                            details provided below.
                        </span>
                    </b-col>
                    <b-col cols="1" class="mt-3">5.3</b-col>
                    <b-col cols="11" class="mt-3">
                        <span>
                            Upon receipt of your written request to withdraw your consent, we may require reasonable time (depending on the complexity of the request and its impact on our relationship with you) for your request to be processed and for us to
                            notify you of the consequences of us acceding to the same, including any legal consequences which may affect your rights and liabilities to us.
                        </span>
                    </b-col>
                    <b-col cols="1" class="mt-3">5.4</b-col>
                    <b-col cols="11" class="mt-3">
                        <span>In general, we shall seek to process your request within ten (10) business days of receiving it.</span>
                    </b-col>
                    <b-col cols="1" class="mt-3">5.5</b-col>
                    <b-col cols="11" class="mt-3">
                        <span>
                            Whilst we respect your decision to withdraw your consent, please note that depending on the nature and scope of your request, we may not be able to continue providing our goods or services to you and we shall, in such circumstances,
                            notify you before completing the processing of your request. Should you decide to cancel your withdrawal of consent, please inform us in writing in the manner described in clause 5.2 above.
                        </span>
                    </b-col>
                    <b-col cols="1" class="mt-3">5.6</b-col>
                    <b-col cols="11" class="mt-3">
                        <span>Please note that withdrawing consent does not affect our right to continue to collect, use and disclose personal data where such collection, use and disclose without consent is permitted or required under applicable laws.</span>
                    </b-col>
                    <b-col cols="1" class="mt-3 font-weight-bold">6</b-col>
                    <b-col cols="11" class="mt-3">
                        <strong>ACCESS TO AND CORRECTION OF PERSONAL DATA</strong>
                    </b-col>
                    <b-col cols="1" class="mt-3">6.1</b-col>
                    <b-col cols="11" class="mt-3">
                        <span>If you wish to make:</span>
                        <b-row>
                            <b-col cols="1">(a)</b-col>
                            <b-col cols="11">
                                <span>an access request for access to a copy of the personal data which we hold about you or information about the ways in which we use or disclose your personal data; or</span>
                            </b-col>
                            <b-col cols="1">(b)</b-col>
                            <b-col cols="11">
                                <span>a correction request to correct or update any of your personal data which we hold about you,</span>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="11" class="offset-1">you may submit your request in writing or via email to our Data Protection Officer at the contact details provided below.</b-col>
                    <b-col cols="1" class="mt-3">6.2</b-col>
                    <b-col cols="11" class="mt-3">
                        <span>
                            We will respond to your request as soon as reasonably possible. Should we not be able to respond to your request within thirty (30) days after receiving your request, we will inform you in writing within thirty (30) days of the time
                            by which we will be able to respond to your request.
                        </span>
                    </b-col>
                    <b-col cols="1" class="mt-3">6.3</b-col>
                    <b-col cols="11" class="mt-3">
                        <span>
                            If we are unable to provide you with any personal data or to make a correction requested by you, we shall generally inform you of the reasons why we are unable to do so (except where we are not required to do so under the Act).
                        </span>
                    </b-col>
                    <b-col cols="1" class="mt-3 font-weight-bold">7</b-col>
                    <b-col cols="11" class="mt-3">
                        <strong>PROTECTION OF PERSONAL DATA</strong>
                    </b-col>
                    <b-col cols="1" class="mt-3">7.1</b-col>
                    <b-col cols="11" class="mt-3">
                        <span>
                            To safeguard your personal data from unauthorised access, collection, use, disclosure, copying, modification, disposal or similar risks, we have introduced appropriate administrative, physical and technical measures such as
                            up-to-date antivirus protection, encryption and the use of privacy filters to secure all storage and transmission of personal data by us, and disclosing personal data both internally and to our authorised third party service
                            providers and agents only on a need-to-know basis.
                        </span>
                    </b-col>
                    <b-col cols="1" class="mt-3">7.2</b-col>
                    <b-col cols="11" class="mt-3">
                        <span>
                            You should be aware, however, that no method of transmission over the Internet or method of electronic storage is completely secure. While security cannot be guaranteed, we strive to protect the security of your information and are
                            constantly reviewing and enhancing our information security measures.
                        </span>
                    </b-col>
                    <b-col cols="1" class="mt-3 font-weight-bold">8</b-col>
                    <b-col cols="11" class="mt-3">
                        <strong>ACCURACY OF PERSONAL DATA</strong>
                        <p class="font-weight-normal mb-0">
                            We generally rely on personal data provided by you (or your Authorised Representative). In order to ensure that your personal data is current, complete and accurate, please update us if there are changes to your personal data by
                            informing our Data Protection Officer at <a href="mailto:support@gofix.com.sg">support@gofix.com.sg</a> or 1800-GOFIXEM (1800 – 4634936).
                        </p>
                    </b-col>
                    <b-col cols="1" class="mt-3 font-weight-bold">9</b-col>
                    <b-col cols="11" class="mt-3">
                        <strong>RETENTION OF PERSONAL DATA</strong>
                    </b-col>
                    <b-col cols="1" class="mt-3">9.1</b-col>
                    <b-col cols="11" class="mt-3">
                        <span>We may retain your personal data for as long as it is necessary to fulfil the purpose for which it was collected, or as required or permitted by applicable laws.</span>
                    </b-col>
                    <b-col cols="1" class="mt-3">9.2</b-col>
                    <b-col cols="11" class="mt-3">
                        <span>
                            We will cease to retain your personal data or remove the means by which the data can be associated with you, as soon as it is reasonable to assume that such retention no longer serves the purpose for which the personal data was
                            collected and is no longer necessary for legal or business purposes.
                        </span>
                    </b-col>
                    <b-col cols="1" class="mt-3 font-weight-bold">10</b-col>
                    <b-col cols="11" class="mt-3">
                        <strong>TRANSFER OF PERSONAL DATA OUTSIDE SINGAPORE</strong>
                    </b-col>
                    <b-col cols="1" class="mt-3">10.1</b-col>
                    <b-col cols="11" class="mt-3">
                        <span>
                            Your Personal Data may be transferred to, stored, used and processed in a country other than Singapore, to our partners in other countries. You understand and consent to the transfer of your Personal Data to our partners in other
                            countries.
                        </span>
                    </b-col>
                    <b-col cols="1" class="mt-3">10.2</b-col>
                    <b-col cols="11" class="mt-3">
                        <span>We will take steps to ensure that your personal data continues to receive a standard of protection that is at least comparable to that provided under the Act.</span>
                    </b-col>
                    <b-col cols="1" class="mt-3 font-weight-bold">11</b-col>
                    <b-col cols="11" class="mt-3">
                        <strong>DATA PROTECTION OFFICER</strong>
                    </b-col>
                    <span class="ml-3 mt-3">
                        You may contact our Data Protection Officer if you have any enquiries or feedback on our personal data protection policies and procedures, or if you wish to make any request at
                        <a href="mailto:support@gofix.com.sg ">support@gofix.com.sg</a> or 1800-GOFIXEM (1800 – 4634936).
                    </span>
                    <b-col cols="1" class="mt-3">12</b-col>
                    <b-col cols="11" class="mt-3">
                        <strong>EFFECT OF POLICY AND CHANGES TO POLICY</strong>
                    </b-col>
                    <b-col cols="1" class="mt-3">12.1</b-col>
                    <b-col cols="11" class="mt-3">
                        <span>This Policy applies in conjunction with any other policies, notices, contractual clauses and consent clauses that apply in relation to the collection, use and disclosure of your personal data by us.</span>
                    </b-col>
                    <b-col cols="1" class="mt-3">12.2</b-col>
                    <b-col cols="11" class="mt-3">
                        <span>We may revise this Notice from time to time without any prior notice. You may determine if any such revision has taken place by referring to the date on which this Policy was last updated.</span>
                    </b-col>
                    <b-col cols="1" class="mt-3">12.3</b-col>
                    <b-col cols="11" class="mt-3">
                        <span>Your continued use of our services constitutes your acknowledgement and acceptance of such changes.</span>
                    </b-col>
                    <b-col cols="1" class="mt-3 font-weight-bold">13</b-col>
                    <b-col cols="11" class="mt-3">
                        <strong>COOKIE POLICY</strong>
                    </b-col>
                    <b-col cols="1" class="mt-3">13.1</b-col>
                    <b-col cols="11" class="mt-3">
                        <span>
                            When you access our Platform, we may send a small data file to your browser, which will store and track information about you (<strong>“Cookies”</strong>). Such information could include how frequently you access our Platform, and
                            what pages that you access, and could include Personal Data. Cookies cannot read and store data off your hard disk.
                        </span>
                    </b-col>
                    <b-col cols="1" class="mt-3">13.2</b-col>
                    <b-col cols="11" class="mt-3">
                        <span>You have the choice of accepting or declining Cookies. You may deactivate Cookies by modifying the settings of your internet browser. However, this may interfere with your taking full advantage of the website.</span>
                    </b-col>
                    <b-col cols="1" class="mt-3">13.3</b-col>
                    <b-col cols="11" class="mt-3">
                        <span>Where you do not deactivate Cookies by modifying the settings of your internet browser, you agree to accept Cookies and the collection of Personal Data through Cookies.</span>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    export default {
        name: 'privacy-policy',
        components: {},
        data() {
            return{}
        },
        created() {},
        methods: {}
    }
</script>
